import {StoreConstants} from '../constants/store.constants';
import type {AnyPayloadAction, DeviceState} from '../models/store.models';
import {storeState} from '../models/store.models';

export function DeviceReducer(state: DeviceState = storeState.Device, action: AnyPayloadAction): DeviceState {
  if (action.group !== StoreConstants.StoreGroups.Device) return state;

  switch (action.type) {
    case StoreConstants.Device.DATA:
      return {
        ...state,
        data: action.data
      };

    default:
      return state;
  }
}
